import type { ApplicationConfig } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import {
  inject,
  isDevMode,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from '@/routes/app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslocoHttpLoader } from '@/transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { authInterceptor } from '@/core/user/auth.interceptor';
import { ProfilePhotoStore } from '@/features/profile-photo-store.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideTransloco({
      config: {
        availableLangs: ['fr'],
        defaultLang: 'fr',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    { provide: LOCALE_ID, useValue: 'fr' },
    provideAppInitializer(() => {
      inject(ProfilePhotoStore);
    }),
  ],
};
